import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE;

const EMOJI_OPTIONS = [
    '1️⃣', '2️⃣', '3️⃣', '4️⃣', '5️⃣', '6️⃣', '7️⃣', '8️⃣', '9️⃣', '🔟',
    '✅', '❌', '👍', '👎', '❤️', '🔥', '⭐', '🎉', '💯', '🚀',
    '👀', '🤔', '👏', '🙏', '💪', '🎮', '🎵', '📅', '💡', '📌'
];

const Umfragen = () => {
    const [question, setQuestion] = useState('');
    const [options, setOptions] = useState(['', '']);
    const [dates, setDates] = useState([]);
    const [dateEmojis, setDateEmojis] = useState([]);
    const [channels, setChannels] = useState([]);
    const [selectedChannelId, setSelectedChannelId] = useState('');
    const [emojis, setEmojis] = useState(['1️⃣', '2️⃣']);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        loadChannels();
    }, []);

    const loadChannels = async () => {
        try {
            const token = localStorage.getItem('discord_token');
            const response = await axios.get(`${API_BASE}/api/discord/channels`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (response.data.success) {
                setChannels(response.data.channels || []);
            }
        } catch (err) {
            console.error('Fehler beim Laden der Channels:', err);
        }
    };

    const handleOptionChange = (index, value) => {
        const newOptions = [...options];
        newOptions[index] = value;
        setOptions(newOptions);
    };

    const handleEmojiChange = (index, emoji) => {
        const newEmojis = [...emojis];
        newEmojis[index] = emoji;
        setEmojis(newEmojis);
    };

    const addOption = () => {
        if (options.length < 10) {
            const nextEmoji = EMOJI_OPTIONS[options.length] || '✅';
            setOptions([...options, '']);
            setEmojis([...emojis, nextEmoji]);
        }
    };

    const removeOption = (index) => {
        if (options.length > 2) {
            setOptions(options.filter((_, i) => i !== index));
            setEmojis(emojis.filter((_, i) => i !== index));
        }
    };

    const addDate = () => {
        if (dates.length < 10) {
            const nextEmoji = EMOJI_OPTIONS[options.length + dates.length] || '✅';
            setDates([...dates, '']);
            setDateEmojis([...dateEmojis, nextEmoji]);
        }
    };

    const handleDateChange = (index, value) => {
        const newDates = [...dates];
        newDates[index] = value;
        setDates(newDates);
    };

    const handleDateEmojiChange = (index, emoji) => {
        const newDateEmojis = [...dateEmojis];
        newDateEmojis[index] = emoji;
        setDateEmojis(newDateEmojis);
    };

    const removeDate = (index) => {
        setDates(dates.filter((_, i) => i !== index));
        setDateEmojis(dateEmojis.filter((_, i) => i !== index));
    };

    const formatDate = (value) => {
        if (!value) return value;
        const dt = new Date(value);
        if (isNaN(dt.getTime())) return value;
        return dt.toLocaleString('de-DE', {
            weekday: 'short',
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const filledOptions = options.filter(o => o.trim());
        const filledDates = dates.filter(d => d);
        const totalOptions = filledOptions.length + filledDates.length;
        if (!question.trim() || totalOptions < 2) {
            setError('Bitte Frage und mindestens 2 Optionen oder Termine ausfüllen.');
            return;
        }
        if (!selectedChannelId) {
            setError('Bitte wähle einen Channel aus.');
            return;
        }

        const allOptions = [
            ...filledOptions,
            ...filledDates.map(formatDate)
        ];
        const allEmojis = [
            ...emojis.slice(0, filledOptions.length),
            ...dateEmojis.slice(0, filledDates.length)
        ];

        setIsLoading(true);
        setError(null);
        setSuccess(false);
        try {
            const token = localStorage.getItem('discord_token');
            const response = await axios.post(`${API_BASE}/api/poll`, {
                question,
                options: allOptions,
                channelId: selectedChannelId,
                emojis: allEmojis,
                dates: filledDates
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (response.data.success) {
                setSuccess(true);
                setQuestion('');
                setOptions(['', '']);
                setDates([]);
                setSelectedChannelId('');
                setEmojis(['1️⃣', '2️⃣']);
                setDateEmojis([]);
            } else {
                throw new Error(response.data.error || 'Fehler beim Erstellen der Umfrage');
            }
        } catch (err) {
            setError(err.response?.data?.error || err.message || 'Fehler beim Erstellen der Umfrage');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="dashboard-main">
            <div className="hero-panel">
                <div>
                    <h2 style={{ margin: 0, fontSize: '1.8rem' }}>📊 Umfragen</h2>
                    <p className="muted small">Einfache Umfragen mit Reactions für Discord</p>
                </div>
            </div>

            <div className="grid">
                <div className="card">
                    <div className="card-header">
                        <h4>Neue Umfrage erstellen</h4>
                    </div>
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="poll-channel">Discord Channel</label>
                                <select
                                    id="poll-channel"
                                    value={selectedChannelId}
                                    onChange={(e) => setSelectedChannelId(e.target.value)}
                                    disabled={isLoading}
                                    style={{ width: '100%', padding: '10px', background: '#333', color: '#fff', border: '1px solid #555', borderRadius: '5px' }}
                                >
                                    <option value="">-- Channel auswählen --</option>
                                    {channels.map(ch => (
                                        <option key={ch.id} value={ch.id}>
                                            {ch.category ? `[${ch.category}] ` : ''}{ch.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="form-group">
                                <label htmlFor="poll-question">Frage</label>
                                <input
                                    id="poll-question"
                                    type="text"
                                    placeholder="Deine Frage?"
                                    value={question}
                                    onChange={(e) => setQuestion(e.target.value)}
                                    disabled={isLoading}
                                />
                            </div>

                            <div className="form-group">
                                <label>Optionen</label>
                                {options.map((opt, index) => (
                                    <div key={index} style={{ display: 'flex', gap: '8px', marginBottom: '8px', alignItems: 'center' }}>
                                        <select
                                            value={emojis[index] || '1️⃣'}
                                            onChange={(e) => handleEmojiChange(index, e.target.value)}
                                            disabled={isLoading}
                                            style={{ width: '80px', padding: '10px', background: '#333', color: '#fff', border: '1px solid #555', borderRadius: '5px', textAlign: 'center' }}
                                        >
                                            {EMOJI_OPTIONS.map(emoji => (
                                                <option key={emoji} value={emoji}>{emoji}</option>
                                            ))}
                                        </select>
                                        <input
                                            type="text"
                                            placeholder={`Option ${index + 1}`}
                                            value={opt}
                                            onChange={(e) => handleOptionChange(index, e.target.value)}
                                            disabled={isLoading}
                                            style={{ flex: 1 }}
                                        />
                                        {options.length > 2 && (
                                            <button
                                                type="button"
                                                className="btn btn-danger"
                                                onClick={() => removeOption(index)}
                                                disabled={isLoading}
                                            >
                                                ✕
                                            </button>
                                        )}
                                    </div>
                                ))}
                                {options.length < 10 && (
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={addOption}
                                        disabled={isLoading}
                                        style={{ marginTop: '8px' }}
                                    >
                                        + Option hinzufügen
                                    </button>
                                )}
                            </div>

                            <div className="form-group">
                                <label>Termine (optional – zum Abstimmen)</label>
                                {dates.map((dt, index) => (
                                    <div key={index} style={{ display: 'flex', gap: '8px', marginBottom: '8px', alignItems: 'center' }}>
                                        <select
                                            value={dateEmojis[index] || '1️⃣'}
                                            onChange={(e) => handleDateEmojiChange(index, e.target.value)}
                                            disabled={isLoading}
                                            style={{ width: '80px', padding: '10px', background: '#333', color: '#fff', border: '1px solid #555', borderRadius: '5px', textAlign: 'center' }}
                                        >
                                            {EMOJI_OPTIONS.map(emoji => (
                                                <option key={emoji} value={emoji}>{emoji}</option>
                                            ))}
                                        </select>
                                        <input
                                            type="datetime-local"
                                            value={dt}
                                            onChange={(e) => handleDateChange(index, e.target.value)}
                                            disabled={isLoading}
                                            style={{ flex: 1 }}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-danger"
                                            onClick={() => removeDate(index)}
                                            disabled={isLoading}
                                        >
                                            ✕
                                        </button>
                                    </div>
                                ))}
                                {dates.length < 10 && (
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={addDate}
                                        disabled={isLoading}
                                        style={{ marginTop: '8px' }}
                                    >
                                        + Termin hinzufügen
                                    </button>
                                )}
                            </div>

                            {error && (
                                <div className="alert alert-error">
                                    <span className="alert-icon">⚠️</span>
                                    <span>{error}</span>
                                </div>
                            )}

                            {success && (
                                <div className="alert alert-success">
                                    <span className="alert-icon">✅</span>
                                    <span>Umfrage erfolgreich erstellt!</span>
                                </div>
                            )}

                            <div className="form-actions">
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={isLoading || !question.trim() || (options.filter(o => o.trim()).length + dates.filter(d => d).length) < 2 || !selectedChannelId}
                                >
                                    {isLoading ? (
                                        <>
                                            <span className="spinner-sm"></span>
                                            Wird erstellt...
                                        </>
                                    ) : (
                                        'Umfrage erstellen'
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Umfragen;
